import { Box, Grid, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import AWSEntityCommonDetails from "./AWSEntityCommonDetails";

const AWSIamUserDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <AWSEntityCommonDetails entityData={entityData} />

      {entityData?.aws_iam_user_data?.group_names &&
        entityData?.aws_iam_user_data?.group_names.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Groups</Typography>
            </Box>
            <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
              {entityData.aws_iam_user_data?.group_names.map(
                (groupName, index) => (
                  <TextIntegrationStyle
                    key={index}
                    title={""}
                    value={groupName}
                  ></TextIntegrationStyle>
                )
              )}
            </Box>
          </Box>
        )}

      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Typography variant={"subtitle2"}>
            Has Permissions Boundary
          </Typography>
        </Box>
        <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
          <TextIntegrationStyle
            title={""}
            value={
              entityData?.aws_iam_user_data?.has_permissions_boundary
                ? "Yes"
                : "No"
            }
          ></TextIntegrationStyle>
        </Box>
      </Box>

      {/* Has Console Access */}
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Typography variant={"subtitle2"}>Has Console Access</Typography>
        </Box>
        <Box ml={2} display={"flex"}>
          <Grid container gap={2} direction={"row"}>
            <Grid item xs={7}>
              <TextIntegrationStyle
                title={""}
                value={
                  entityData?.aws_iam_user_data?.has_console_access
                    ? "Yes"
                    : "No"
                }
              ></TextIntegrationStyle>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* Has Access Keys */}
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Typography variant={"subtitle2"}>Has Access Keys</Typography>
        </Box>
        <Box ml={2} display={"flex"}>
          <TextIntegrationStyle
            title={""}
            value={
              entityData?.aws_iam_user_data?.has_access_keys ? "Yes" : "No"
            }
          ></TextIntegrationStyle>
        </Box>
      </Box>
    </Box>
  );
};

export default AWSIamUserDetailsView;
